/* THE ILLUMINATEE - product gallery cleanup.
   Hides the thumbnail strips and arrows, and locks the fullscreen zoom view to
   only the image that was opened, so colour swatches are the only way to change
   the product image. Finds the Color fieldset via its <legend>. */
(function () {
  'use strict';
  if (window.__illGalleryClean) return;   // guard against an accidental double-paste
  window.__illGalleryClean = true;

  // 4 — Lock the fullscreen (zoom) view to only the image that was opened.

  // Best URL we can read for an <img> WITHOUT waiting for it to load
  // (the zoom photos are lazy, so we read the markup, not the loaded pixels).
  function imgUrl(im){
    if (!im) return '';
    if (im.currentSrc) return im.currentSrc;
    if (im.getAttribute('src')) return im.getAttribute('src');
    var ss = im.getAttribute('srcset') || im.getAttribute('data-srcset');
    if (ss) return ss.trim().split(',')[0].trim().split(' ')[0];
    return im.getAttribute('data-src') || '';
  }
  // Reduce a Shopify CDN url to a stable file id (drop the ?query and the _600x size suffix).
  function fileId(u){
    if (!u) return '';
    try { return u.split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, '').toLowerCase(); }
    catch (e) { return ''; }
  }
  // The product photo currently shown in the main gallery.
  function currentMainFileId(){
    var v = document.querySelector('media-gallery slideshow-container');
    if (!v) return '';
    var box = v.getBoundingClientRect(), best = null, bestArea = 0;
    v.querySelectorAll('slideshow-slide img').forEach(function (im){
      var r = im.getBoundingClientRect();
      var w = Math.max(0, Math.min(r.right,  box.right)  - Math.max(r.left, box.left));
      var h = Math.max(0, Math.min(r.bottom, box.bottom) - Math.max(r.top,  box.top));
      if (w * h > bestArea){ bestArea = w * h; best = im; }
    });
    return fileId(imgUrl(best));
  }
  // Fallback: the index of the selected colour (the zoom items are in colour order).
  function selectedColorIndex(){
    var fs = Array.prototype.slice.call(document.querySelectorAll('fieldset')).find(function (f){
      var l = f.querySelector('legend, .form__label, label');
      return l && /colou?r/i.test(l.textContent || '');
    });
    if (!fs) return -1;
    return Array.prototype.slice.call(fs.querySelectorAll('input[type=radio]'))
      .findIndex(function (r){ return r.checked; });
  }

  // Show only the zoom item matching the current photo; hide the rest.
  function lockDialog(dlg){
    var ul = dlg.querySelector('.dialog-zoomed-gallery');
    if (!ul) return;
    var items = Array.prototype.slice.call(ul.children);
    if (!items.length) return;

    var want = currentMainFileId();
    var target = -1;
    if (want){
      target = items.findIndex(function (li){ return fileId(imgUrl(li.querySelector('img'))) === want; });
    }
    if (target < 0){                                   // fallback: match by colour order
      var ci = selectedColorIndex();
      if (ci >= 0 && ci < items.length) target = ci;
    }
    if (target < 0) target = 0;

    items.forEach(function (li, i){
      li.style.setProperty('display', i === target ? '' : 'none', 'important');
    });
  }
  // Restore all items when the dialog closes, so the next open recomputes fresh.
  function unlockDialog(dlg){
    var ul = dlg.querySelector('.dialog-zoomed-gallery');
    if (ul) Array.prototype.forEach.call(ul.children, function (li){ li.style.removeProperty('display'); });
  }

  // Watch a zoom <dialog> for open/close.
  function watch(dlg){
    if (dlg.__illWatched) return;
    dlg.__illWatched = true;
    new MutationObserver(function (){
      if (dlg.open || dlg.hasAttribute('open')) lockDialog(dlg); else unlockDialog(dlg);
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    if (dlg.open || dlg.hasAttribute('open')) lockDialog(dlg);
  }
  function scan(){ document.querySelectorAll('zoom-dialog dialog').forEach(watch); }

  function init(){
    scan();
    // Re-scan (debounced) in case the gallery/dialog is re-rendered on variant change.
    if ('MutationObserver' in window){
      var queued = false;
      new MutationObserver(function (){
        if (queued) return;
        queued = true;
        setTimeout(function (){ queued = false; scan(); }, 200);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
